import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {AppVersion, ManagerVersion} from '../restaurant-manager.models';
import {map} from 'rxjs/operators';
import {ApiService} from './api.service';

@Injectable({
  providedIn: 'root'
})
export class VersionService {

  constructor(
    private apiService: ApiService
  ) { }

  getLastAppVersion(): Observable<AppVersion> {
    return this.apiService.get<AppVersion>('/version', false).pipe(map(result => new AppVersion(result)));
  }

  getLastManagerVersion(): Observable<ManagerVersion> {
    return this.apiService.get<ManagerVersion>('/api/manager/version', false, false).pipe(map(result => new ManagerVersion(result)));
  }

}
